import styled, { css } from 'styled-components';

export const EmailContainer = styled.div`
  display: inline-block;
  ${(props) =>
    props.inline &&
    css`
      margin-left: 0;
      margin-right: 30px;
      margin-bottom: 5px;
    `}
`;
